import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import { FormGroup, FormControl, ControlLabel, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import FileUploader from "react-firebase-file-uploader";
import { ThreeBounce } from "better-react-spinkit";

import { getBoard, getImage } from "src/utils/Firebase";

import css from "./NewBoard.scss";

const cx = classnames.bind(css);
const moduleName = "UpdateBoard";

const UpdateBoard = ({ board }) => {
  const [redirect, setRedirect] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    if (!board.data) {
      setRedirect(true);
      return;
    }
    const selectedData = board.data.filter((val) => val.id === board.selectedId);
    if (selectedData.length > 0) {
      setTitle(selectedData[0].title);
      setContent(selectedData[0].content);
    }
  }, []);

  const handleUploadStart = () => setIsUploading(true);
  const handleProgress = () => {};
  const handleUploadError = (error) => {
    setIsUploading(false);
    console.error(error);
  };
  const handleUploadSuccess = (filename) => {
    setIsUploading(false);
    getImage().child(filename).getDownloadURL();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const boardId = board.selectedId;
    const newTask = { id: boardId, title, content };
    getBoard()
      .child(boardId)
      .update(newTask)
      .then(() => setRedirect(true));
  };

  if (redirect) return <Redirect to="/board" />;

  return (
    <div className={cx(`${moduleName}`)}>
      <h4>글을 작성하는 화면입니다.</h4>
      <div className={cx(`${moduleName}`)}>
        <form onSubmit={handleSubmit}>
          <FormGroup controlId="formTitle" validationState="success">
            <ControlLabel>Title</ControlLabel>
            <FormControl
              type="text"
              placeholder="제목"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormGroup>
          <FormGroup controlId="formContent" validationState="success">
            <ControlLabel>Textarea</ControlLabel>
            <FormControl
              componentClass="textarea"
              placeholder="내용"
              value={content}
              className={cx(`${moduleName}-content`)}
              onChange={(e) => setContent(e.target.value)}
            />
          </FormGroup>
          <FileUploader
            accept="image/*"
            name="avatar"
            filename={() => board.data && "board" + board.selectedId}
            storageRef={getImage()}
            onUploadStart={handleUploadStart}
            onUploadError={handleUploadError}
            onUploadSuccess={handleUploadSuccess}
            onProgress={handleProgress}
          />
          {isUploading ? (
            <div>
              <ThreeBounce size={15} color="#265E4B" />
              <p>사진이 업로드 중입니다.!</p>
            </div>
          ) : (
            <Button type="submit">Submit</Button>
          )}
        </form>
      </div>
    </div>
  );
};

export default connect(({ board }) => ({ board }))(UpdateBoard);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Boards/components/UpdateBoard.js